import React, { useContext } from "react";
export const DesignContext = React.createContext(null);
export const useDesignContext = () => useContext(DesignContext);
